import axios from 'axios';
import { getAllCookies } from './cookies';
import { getGoogleAnalyticsClientId } from './google';

const getContextData = () => {
	const context = {
		pageUri: window.location.href,
		pageName: document.title,
	};

	const cookies = getAllCookies();
	if (cookies['hubspotutk']) {
		context.hutk = cookies['hubspotutk'];
	}

	return context;
};

const getLegalConsentData = ({ consentText, country, hubspotData, region }) => {
	// Subscriptions
	const communications = [];
	hubspotData.subscriptions.forEach((subscription) => {
		// If the user's region matches the target region in the current subscription data
		let subscribe = true;
		if (subscription.filter) {
			switch (subscription.filter.type) {
				case 'region':
					subscribe = subscription.filter.value === region; // Filter value is a string.
					break;
				case 'country':
					subscribe = subscription.filter.value.includes(country); // Filter value is an array.
					break;
			}
		}

		subscribe &&
			communications.push({
				value: true,
				subscriptionTypeId: subscription.subscription_type_id,
				text: subscription.consent_text,
			});
	});

	return {
		consent: {
			consentToProcess: true,
			text: consentText,
			communications,
		},
	};
};

export const submitHubSpotForm = async ({ consentText, country, formData, hubspotData, region, trialRegistrationMethod, url }) => {
	// Enrich formData with additional fields
	formData.push({ name: 'trial_registration_method', value: trialRegistrationMethod });
	const gaClientId = getGoogleAnalyticsClientId();
	if (gaClientId) {
		formData.push({ name: 'ga_client_id', value: gaClientId });
	}

	const data = {
		context: getContextData(),
		fields: formData,
		legalConsentOptions: getLegalConsentData({ consentText, country, hubspotData, region }),
	};

	try {
		await axios.post(url, {
			hs_route: hubspotData.formSubmissionUrl,
			hs_data: JSON.stringify(data),
		});
	} catch (error) {
		console.error('Error submitting HubSpot form:', error);
	}
};

export const updateHubSpotContact = async ({ email, properties, url }) => {
	try {
		const formData = new FormData();
		formData.append('email', email);
		formData.append('properties', JSON.stringify(properties));
		await axios.post(url, formData);
	} catch (error) {
		console.error('Error updating HubSpot contact:', error);
	}
};
